import { Modal, Row, Col, Form} from 'react-bootstrap'
import { useEffect, useState, useRef } from "react";
import { Dropdown, Button } from "react-bootstrap";
import Spinner from 'react-bootstrap/Spinner';
import { FormInputElement } from '../../Form/FormInputElement';
import { useApiClient } from '../../../ApiService/useApiClient';


const EditClientSection2 = ({show,setShowAddEdit, data, setdata}) => {

    const api = useApiClient();

    const formDefault = {
        opened: true,
        modalTitle:"Client Details",  
      }
  
      const [formModal, setFormModal] = useState(formDefault);
      const [error,setError] = useState(null);
      const modalForm = useRef(null);
      

      useEffect(()=>{

        setFormModal({...formModal, opened:show , action:'add'
                , medicalNotes:data.medicalNotes,
                Likes:data.likes,
                disLikes:data.disLikes,
                specialRequirments:data.specialRequirments       
                });        

      },[show]);

      
    function closeFormModal(){
        const updateFormModal = {...formModal, opened:false}
        setFormModal(updateFormModal);
        setShowAddEdit(false);
      }
  

      function handleAddEvent(e){        
        closeFormModal();
    }

    function handleEditEvent(e){     
      //closeFormModal();
  }


      function handleFormSubmit(event){
  
        event.preventDefault();
        let medicalNotes = modalForm.current.querySelector('#medicalNotes').value; 
        let Likes = modalForm.current.querySelector('#Likes').value; 
        let disLikes = modalForm.current.querySelector('#disLikes').value; 
        let specialRequirments = modalForm.current.querySelector('#specialRequirments').value; 
                          
       
  
        const frmFormData = new FormData();
        frmFormData.append("CustomerId", data.customerId) 
        frmFormData.append("MedicalNotes", medicalNotes) 
        frmFormData.append("Likes", Likes) 
        frmFormData.append("DisLikes", disLikes)  
        frmFormData.append("SpecialRequirments", specialRequirments)  
      
        const sURL = "HMCareData/customer/modify/";
                
        api.post(sURL,frmFormData)
        .then((Response)=>{

            let updatedDataObj = Response.data;              
            setdata(updatedDataObj)          
            closeFormModal();
                        
        }).catch(error => {
            setError(error);     
            console.log({error})
        });
        
      return null
          
      
    }


  return (
    <Modal show={formModal.opened} onHide={closeFormModal} size="lg" backdrop="static">
<Form ref={modalForm} onSubmit={handleFormSubmit}>
    <Modal.Header closeButton>
    <Modal.Title className="event-title" as="h4">{formModal.modalTitle}</Modal.Title>
    </Modal.Header>                
    <Modal.Body>

        {false && <Spinner animation="border" variant="primary" />}             

        {<Row className="g-gs">           

            <FormInputElement type="textarea" id="medicalNotes" ColWidth={12} maxLength={100} Label="Medical Notes" defaultValue={formModal.medicalNotes}  placeholder="Medical Notes"/>
            <FormInputElement type="text" id="Likes" ColWidth={12} maxLength={150} Label="Likes" defaultValue={formModal.Likes}  placeholder="Likes"/>
            <FormInputElement type="text" id="disLikes" ColWidth={12} maxLength={100} Label="Dis-Likes" defaultValue={formModal.disLikes}  placeholder="Dis-Likes"/>
            <FormInputElement type="textarea" id="specialRequirments" ColWidth={12} maxLength={100} Label="Special Requirments" defaultValue={formModal.specialRequirments}  placeholder="Special Requirments"/>
            
        </Row>}
    </Modal.Body>
    <Modal.Footer>                    
        <Button variant="danger" onClick={closeFormModal}>Discard</Button>        
        {/* <Button variant="primary" type="submit" onClick={handleEditEvent}>Update</Button> */}
        <Button variant="primary" type="submit" onClick={handleEditEvent}>Update</Button>
    </Modal.Footer>
</Form>
</Modal>
  )
}

export default EditClientSection2